export default "__VITE_ASSET__VxLIu5qK__"